import BusinessPlanCard from "./BusinessPlanCard";
import { CUSTOM_PLAN } from "../../constants/landingPage";
import { useTranslation } from "react-i18next";

const PlansOptions = ({ subscriptionPlans, isLoading, isError }) => {
  const { t } = useTranslation('signup');

  if (isLoading) return;
  if (isError) return;

  const sortedPlans = [...(subscriptionPlans || [])].sort((a, b) => {
    if (a.plan_type === 'enterprise' && b.plan_type !== 'enterprise') return 1;
    if (a.plan_type !== 'enterprise' && b.plan_type === 'enterprise') return -1;
    return 0;
  });

  return (
    <div className="plans-options" id="business-plans">
      <div className="plans-options__heading">
        <p className="plans-options__title">
          خيارات مرنة وأسعار واضحة{" "}
          <br className="plans-options__title-br" />
          <span className="plans-options__title-span">لكل المؤسسات والفرق</span>
        </p>
        <p className="plans-options__subtitle">مقارنة سريعة بين أنظمة الإشتراك بين الشركات</p>
      </div>
      <div className="plans-options__cards">
        {sortedPlans.map((plan) => (
          <BusinessPlanCard
            key={plan?.id}
            title={plan?.title}
            subTitle={plan?.subtitle ? plan?.subtitle : ""}
            buttonTitle={t("start_now")}
            benefitsList={plan?.description}
            buttonLink={`/signup/${plan?.slug}`}
            expanded={plan?.plan_type === 'enterprise'}
            minSeats={plan?.min_seat}
            maxSeats={plan?.max_seat}
          />
        ))}
      </div>
    </div>
  );
};

export default PlansOptions;
